import script from "./InvoiceDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceDialog.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceDialog.vue?vue&type=style&index=0&id=5e1ec6ef&lang=scss&scoped=true"

import exportComponent from "E:\\online_project\\app_pcw365\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e1ec6ef"]])

export default __exports__